import React, { Fragment,useEffect } from "react";
import Header from "../components/header";
import PageTitle from "../components/pagetitle";
import ProjectSingle4 from "../components/projectsingle4";
import Testimonial from "../components/testimonial";
import Footer from "../components/footer";
import ScrollToTop from "react-scroll-to-top";

const ProjectPage = () => {
useEffect(()=>{
    window.scrollTo(0,0)    
  })
  return (
    <Fragment>
      <Header />
      <PageTitle pageTitle={"EVERSMILE"} pagesub={"Project Details"} />
      <ProjectSingle4 />
      <Testimonial />
      <Footer />
    </Fragment>
  );
};
export default ProjectPage;
